import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ContractDetailsComponent } from '../contract-details.component';
import { AppComponent } from 'src/app/app.component';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-completed-contract',
  templateUrl: './completed-contract.component.html',
  styleUrls: ['./completed-contract.component.scss']
})
export class CompletedContractComponent implements OnInit {

  @Input() contractData: any
  @ViewChild('closeBtn') closeBtn: ElementRef;
  errorMsg: boolean;

  role: any;

  constructor(private contractDetails: ContractDetailsComponent, private appComp: AppComponent, private authService: AuthenticationService, private router: Router) { }

  ngOnInit(): void {

    this.role = this.authService.getUserRole();
  }

  completeContract(){
    this.appComp.loading = true;
    this.errorMsg = false;
    this.contractData.isCompleted = 1;
    console.log(this.contractData);
    delete this.contractData["contractInstallments"];
    this.authService.updateContract(this.contractData).then(res=>{
      console.log(res);
      this.closeBtn.nativeElement.click();
      this.appComp.loading = false;
      this.contractDetails.getContractDetails();

    }, err=>{
      console.log(err);
      this.appComp.loading = false;
      this.errorMsg = true;
    })
  }

}
